/* Lorelia Studio — ein Konfigurator für Sternenkarte und Landkarte.
   Ein Schritt nach dem anderen, Vorlagen statt Optionsflut.
   Sterne: d3-celestial (Olaf Frohn, BSD-3). Karten: OpenFreeMap/OpenStreetMap via MapLibre.
   Ortssuche: Photon (Komoot). Alles wird im Browser gezeichnet. */
(function () {
  var DEG = Math.PI / 180;

  /* ================= Astronomie ================= */
  function julian(d) { return d.getTime() / 86400000 + 2440587.5; }
  function lstDeg(date, lonEast) {
    var JD = julian(date), T = (JD - 2451545.0) / 36525;
    var g = 280.46061837 + 360.98564736629 * (JD - 2451545.0) + 0.000387933 * T * T - T * T * T / 38710000;
    return (((g + lonEast) % 360) + 360) % 360;
  }
  function altaz(ra, dec, lst, lat) {
    var H = ((((lst - ra) % 360) + 360) % 360) * DEG, d = dec * DEG, p = lat * DEG;
    var alt = Math.asin(Math.max(-1, Math.min(1, Math.sin(d) * Math.sin(p) + Math.cos(d) * Math.cos(p) * Math.cos(H))));
    var az = Math.atan2(-Math.sin(H) * Math.cos(d), Math.cos(p) * Math.sin(d) - Math.sin(p) * Math.cos(d) * Math.cos(H));
    return [alt / DEG, ((az / DEG) + 360) % 360];
  }
  function moonPhase(date) { var n = (julian(date) - 2451550.1) / 29.530588853; return n - Math.floor(n); }
  function moonName(p) {
    if (p < .03 || p > .97) return 'Neumond';
    if (p < .22) return 'zunehmende Sichel'; if (p < .28) return 'zunehmender Halbmond';
    if (p < .47) return 'zunehmender Mond'; if (p < .53) return 'Vollmond';
    if (p < .72) return 'abnehmender Mond'; if (p < .78) return 'abnehmender Halbmond';
    return 'abnehmende Sichel';
  }

  /* ================= Stile ================= */
  var STYLES = {
    abendgruen:  { name: 'Abendgrün',   paper: '#1E3A32', ink: '#F3EFE7', accent: '#C9A227', sky: '#12241F', star: '#FFFFFF', line: '#C9A227', lineA: .5,  mw: '#FFFFFF', mwA: .06, land: '#1E3A32', water: '#16302A', road: '#F3EFE7', roadA: .8,  build: .10 },
    elfenbein:   { name: 'Elfenbein',   paper: '#F4EFE6', ink: '#1C1B19', accent: '#9C8047', sky: '#12332B', star: '#FFFFFF', line: '#FFFFFF', lineA: .55, mw: '#FFFFFF', mwA: .07, land: '#F4EFE6', water: '#E4DCCB', road: '#1C1B19', roadA: .8,  build: .09 },
    mitternacht: { name: 'Mitternacht', paper: '#0B1220', ink: '#F2F0EC', accent: '#C9A227', sky: '#0B1220', star: '#FFFFFF', line: '#FFFFFF', lineA: .35, mw: '#9FB6D6', mwA: .08, land: '#0B1220', water: '#131C2E', road: '#F2F0EC', roadA: .75, build: .09 },
    anthrazit:   { name: 'Anthrazit',  paper: '#22211F', ink: '#F2F0EC', accent: '#F2F0EC', sky: '#191817', star: '#FFFFFF', line: '#FFFFFF', lineA: .4,  mw: '#FFFFFF', mwA: .07, land: '#22211F', water: '#2C2B28', road: '#F2F0EC', roadA: .78, build: .10 },
    nachthimmel: { name: 'Schwarzer Himmel', paper: '#FFFFFF', ink: '#1C1B19', accent: '#1C1B19', sky: '#0B0B0C', star: '#FFFFFF', line: '#FFFFFF', lineA: .42, mw: '#FFFFFF', mwA: .07, land: '#FFFFFF', water: '#E7E6E2', road: '#1C1B19', roadA: .85, build: .10 },
    tinte:       { name: 'Tinte',       paper: '#FFFFFF', ink: '#1C1B19', accent: '#1C1B19', sky: '#FFFFFF', star: '#1C1B19', line: '#1C1B19', lineA: .35, mw: '#1C1B19', mwA: .05, land: '#FFFFFF', water: '#E7E6E2', road: '#1C1B19', roadA: .85, build: .10 }
  };

  /* ================= Vorlagen ================= */
  var LAYOUTS = {
    kreis:        { name: 'Klassisch',     hint: 'Kreis oben, Worte unten',      slots: ['a'] },
    passepartout: { name: 'Passepartout',  hint: 'feine Linie, ruhiger Rand',    slots: ['a'], border: true },
    randlos:      { name: 'Randlos',       hint: 'füllt das ganze Blatt',        slots: ['a'], veil: true },
    herz:         { name: 'Herz',          hint: 'für Paare',                    slots: ['a'] },
    duo:          { name: 'Zwei Orte',     hint: 'zwei Momente, ein Blatt',      slots: ['a', 'b'], second: true },
    kombi:        { name: 'Himmel + Karte',hint: 'beides aus derselben Nacht',   slots: ['a', 'b'], mixed: true }
  };

  /* ================= Sternenhimmel ================= */
  function drawSky(ctx, W, H, o, sky, cover) {
    var st = STYLES[o.style] || STYLES.abendgruen;
    var u = Math.min(W, H) / 420;
    var cx = W / 2, cy = H / 2, R = (cover ? Math.max(W, H) : Math.min(W, H)) / 2;
    ctx.clearRect(0, 0, W, H);
    ctx.fillStyle = st.sky; ctx.fillRect(0, 0, W, H);
    var L = lstDeg(o.date, o.lon), lat = o.lat;
    function pt(ra, dec) {
      var aa = altaz(ra, dec, L, lat);
      if (aa[0] < -0.5) return null;
      var rho = R * Math.tan(((90 - aa[0]) / 2) * DEG);
      return [cx - rho * Math.sin(aa[1] * DEG), cy - rho * Math.cos(aa[1] * DEG)];
    }
    if (o.mw && sky.mw) {
      ctx.fillStyle = st.mw; ctx.globalAlpha = st.mwA;
      for (var m = 0; m < sky.mw.length; m++) {
        var ring = sky.mw[m], on = false; ctx.beginPath();
        for (var i = 0; i < ring.length; i++) {
          var p = pt(ring[i][0], ring[i][1]); if (!p) { on = false; continue; }
          if (!on) { ctx.moveTo(p[0], p[1]); on = true; } else ctx.lineTo(p[0], p[1]);
        }
        ctx.closePath(); ctx.fill();
      }
      ctx.globalAlpha = 1;
    }
    if (o.grid) {
      ctx.strokeStyle = st.star; ctx.globalAlpha = .12; ctx.lineWidth = .7 * u;
      for (var a2 = 15; a2 < 90; a2 += 15) { ctx.beginPath(); ctx.arc(cx, cy, R * Math.tan(((90 - a2) / 2) * DEG), 0, 2 * Math.PI); ctx.stroke(); }
      for (var a = 0; a < 360; a += 30) { ctx.beginPath(); ctx.moveTo(cx, cy); ctx.lineTo(cx - R * Math.sin(a * DEG), cy - R * Math.cos(a * DEG)); ctx.stroke(); }
      ctx.globalAlpha = 1;
    }
    if (o.lines && sky.lines) {
      ctx.strokeStyle = st.line; ctx.globalAlpha = st.lineA; ctx.lineWidth = 1 * u; ctx.lineCap = 'round'; ctx.lineJoin = 'round';
      for (var l = 0; l < sky.lines.length; l++) {
        var seg = sky.lines[l], onl = false; ctx.beginPath();
        for (var k = 0; k < seg.length; k++) {
          var q = pt(seg[k][0], seg[k][1]); if (!q) { onl = false; continue; }
          if (!onl) { ctx.moveTo(q[0], q[1]); onl = true; } else ctx.lineTo(q[0], q[1]);
        }
        ctx.stroke();
      }
      ctx.globalAlpha = 1;
    }
    ctx.fillStyle = st.star;
    for (var j = 0; j < sky.stars.length; j++) {
      var s = sky.stars[j], pp = pt(s[0], s[1]); if (!pp) continue;
      ctx.globalAlpha = Math.min(1, .32 + (6.4 - s[2]) * .17);
      ctx.beginPath(); ctx.arc(pp[0], pp[1], Math.max(.4 * u, (6.4 - s[2]) * .5 * u), 0, 2 * Math.PI); ctx.fill();
    }
    ctx.globalAlpha = 1;
    if (o.names && sky.names) {
      ctx.fillStyle = st.star; ctx.globalAlpha = .5; ctx.textAlign = 'center';
      ctx.font = (9 * u) + 'px Karla, Arial, sans-serif';
      for (var n = 0; n < sky.names.length; n++) {
        var nm = sky.names[n], np = pt(nm[0], nm[1]); if (!np) continue;
        if (Math.hypot(np[0] - cx, np[1] - cy) > R * .92) continue;
        ctx.fillText(String(nm[2]).toUpperCase(), np[0], np[1]);
      }
      ctx.globalAlpha = 1;
    }
  }

  /* ================= Kartenstil ================= */
  function mapStyleFor(preset, base) {
    var st = STYLES[preset], s = JSON.parse(JSON.stringify(base));
    s.layers = s.layers.filter(function (l) { return l.type !== 'symbol'; });
    s.layers.forEach(function (l) {
      var id = (l.id || '').toLowerCase(); l.paint = l.paint || {};
      if (l.type === 'background') l.paint['background-color'] = st.land;
      else if (l.type === 'fill') {
        if (/water|ocean|sea|river|lake/.test(id)) { l.paint['fill-color'] = st.water; l.paint['fill-opacity'] = 1; }
        else if (/building/.test(id)) { l.paint['fill-color'] = st.road; l.paint['fill-opacity'] = st.build; }
        else if (/park|wood|forest|grass|landcover|landuse|sand|glacier/.test(id)) { l.paint['fill-color'] = st.road; l.paint['fill-opacity'] = .05; }
        else { l.paint['fill-color'] = st.land; l.paint['fill-opacity'] = .3; }
      } else if (l.type === 'line') {
        if (/water|river|stream|canal/.test(id)) { l.paint['line-color'] = st.water; l.paint['line-opacity'] = 1; }
        else if (/motorway|trunk|primary/.test(id)) { l.paint['line-color'] = st.road; l.paint['line-opacity'] = st.roadA; }
        else if (/secondary|tertiary|street|road|path|rail|transit/.test(id)) { l.paint['line-color'] = st.road; l.paint['line-opacity'] = st.roadA * .55; }
        else if (/boundary|admin/.test(id)) { l.paint['line-color'] = st.road; l.paint['line-opacity'] = .22; }
        else { l.paint['line-color'] = st.road; l.paint['line-opacity'] = st.roadA * .35; }
      } else if (l.type === 'raster') l.paint['raster-opacity'] = 0;
    });
    return s;
  }

  /* ================= Hilfen ================= */
  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function fmtCoords(lat, lon) {
    function part(v, pos, neg) {
      var d = Math.abs(v), deg = Math.floor(d), min = Math.round((d - deg) * 60);
      if (min === 60) { deg += 1; min = 0; }
      return deg + '°' + pad(min) + '′ ' + (v >= 0 ? pos : neg);
    }
    return part(lat, 'N', 'S') + ' · ' + part(lon, 'O', 'W');
  }
  var MON = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];
  function fmtDate(d) { return d.getDate() + '. ' + MON[d.getMonth()] + ' ' + d.getFullYear(); }
  function debounce(fn, ms) { var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, ms); }; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]; }); }
  function parseLocal(v) { var m = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/.exec(String(v)); return m ? new Date(+m[1], +m[2] - 1, +m[3], +m[4], +m[5]) : new Date(v); }
  function localStr(d) { return [d.getFullYear(), pad(d.getMonth() + 1), pad(d.getDate())].join('-') + 'T' + pad(d.getHours()) + ':' + pad(d.getMinutes()); }

  /* ================= Konfigurator ================= */
  function init(root) {
    var el = function (s) { return root.querySelector(s); }, all = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
    var MODE = root.dataset.mode === 'karte' ? 'karte' : 'stern';
    var poster = el('[data-poster]'), sky = null, mapBase = null, maps = {}, mapLoading = false;

    var FORMATS = { '40x30': { label: '40 × 30 cm', ohne: 24.99, rahmen: 54.99 }, '60x40': { label: '60 × 40 cm', ohne: null, rahmen: 79.99 } };
    var ADDONS = { digital: 9.90, prio: 4.95 };

    var state = {
      layout: 'kreis', style: 'nachthimmel',
      lines: true, names: false, mw: true, grid: false, zoom: 13, zoom2: 13,
      lat: 48.7784, lon: 9.18, place: 'Stuttgart, Deutschland',
      lat2: 53.5503, lon2: 9.9920, place2: 'Hamburg, Deutschland',
      date: new Date(), kicker: MODE === 'karte' ? 'Wo alles begann' : 'Die Nacht, in der alles begann',
      title: MODE === 'karte' ? 'Stuttgart' : 'Anna & Jonas', sub: '',
      format: '40x30', frame: 'ohne', frameColor: 'schwarz',
      digital: false, prio: false, erinnerung: true
    };
    state.date.setHours(21, 0, 0, 0);
    var h = readHash(); if (h) Object.keys(h).forEach(function (k) { state[k] = h[k]; });
    if (!(state.date instanceof Date) || isNaN(state.date)) { state.date = new Date(); state.date.setHours(21, 0, 0, 0); }

    fetch(root.dataset.sky).then(function (r) { return r.json(); }).then(function (d) { sky = d; build(); });

    function needMap() { return MODE === 'karte' || LAYOUTS[state.layout].mixed; }
    function kindFor(slot) {
      var L = LAYOUTS[state.layout];
      if (L.mixed) return slot === 'a' ? MODE : (MODE === 'stern' ? 'karte' : 'stern');
      return MODE;
    }
    function ensureMapLib(cb) {
      if (window.maplibregl) return cb();
      if (mapLoading) return setTimeout(function () { ensureMapLib(cb); }, 120);
      mapLoading = true;
      var s = document.createElement('script'); s.src = root.dataset.maplibre;
      s.onload = function () { cb(); }; document.head.appendChild(s);
    }

    /* --- Poster aufbauen --- */
    function build() {
      var L = LAYOUTS[state.layout], st = STYLES[state.style];
      poster.className = 'lr-po lr-po--' + state.layout;
      poster.style.background = st.paper; poster.style.color = st.ink;
      poster.style.setProperty('--po-paper', st.paper);
      poster.innerHTML = '';
      Object.keys(maps).forEach(function (k) { try { maps[k].remove(); } catch (e) {} delete maps[k]; });

      L.slots.forEach(function (slot) {
        var art = document.createElement('div');
        art.className = 'lr-po__art lr-po__art--' + slot;
        art.setAttribute('data-slot', slot);
        poster.appendChild(art);
        if (kindFor(slot) === 'stern') art.appendChild(document.createElement('canvas'));
        else { var d = document.createElement('div'); d.className = 'lr-po__map'; art.appendChild(d); }
      });
      if (L.veil) {
        var v = document.createElement('div'); v.className = 'lr-po__veil';
        v.style.background = 'linear-gradient(transparent, ' + st.paper + ' 72%)';
        poster.appendChild(v);
      }
      if (L.second) {
        ['a', 'b'].forEach(function (slot) {
          var cap = document.createElement('p');
          cap.className = 'lr-po__cap lr-po__cap--' + slot;
          cap.setAttribute('data-cap', slot);
          poster.appendChild(cap);
        });
      }
      if (L.border) { var b = document.createElement('div'); b.className = 'lr-po__border'; poster.appendChild(b); }

      var txt = document.createElement('div'); txt.className = 'lr-po__txt';
      txt.innerHTML = '<p class="lr-po__k" data-po-k></p><p class="lr-po__t" data-po-t></p><p class="lr-po__s" data-po-s></p><p class="lr-po__c" data-po-c></p>';
      poster.appendChild(txt);
      var osm = el('[data-osm]'); if (osm) osm.hidden = !needMap();
      var t = el('[data-po-t]'); if (t) t.style.color = st.accent;
      paintSlots(); syncTexts(); renderThumbs();
    }

    /* --- Inhalte --- */
    var lastMs = 0;
    function paintSlots() {
      var L = LAYOUTS[state.layout];
      L.slots.forEach(function (slot) {
        var art = poster.querySelector('[data-slot="' + slot + '"]'); if (!art) return;
        var kind = kindFor(slot), second = (slot === 'b' && L.second);
        var o = {
          style: state.style, lines: state.lines, names: state.names, mw: state.mw, grid: state.grid,
          lat: second ? state.lat2 : state.lat, lon: second ? state.lon2 : state.lon, date: state.date
        };
        if (kind === 'stern') {
          var c = art.querySelector('canvas'); if (!c || !sky) return;
          var r = art.getBoundingClientRect(), dpr = Math.min(2, window.devicePixelRatio || 1);
          var w = Math.max(80, Math.round(r.width * dpr)), hh = Math.max(80, Math.round(r.height * dpr));
          if (c.width !== w || c.height !== hh) { c.width = w; c.height = hh; }
          var t0 = performance.now();
          drawSky(c.getContext('2d'), w, hh, o, sky, state.layout === 'randlos');
          lastMs = Math.round(performance.now() - t0);
        } else {
          var holder = art.querySelector('.lr-po__map'); if (!holder) return;
          ensureMapLib(function () {
            var center = [second ? state.lon2 : state.lon, second ? state.lat2 : state.lat];
            var zoom = second ? state.zoom2 : state.zoom;
            if (maps[slot]) { maps[slot].jumpTo({ center: center, zoom: zoom }); maps[slot].resize(); return; }
            art.classList.add('is-laden');
            function start(base) {
              maps[slot] = new maplibregl.Map({
                container: holder, style: mapStyleFor(state.style, base), center: center, zoom: zoom,
                attributionControl: false, dragRotate: false, pitchWithRotate: false
              });
              maps[slot].on('moveend', function () {
                var c2 = maps[slot].getCenter();
                if (second) { state.lat2 = c2.lat; state.lon2 = c2.lng; state.zoom2 = maps[slot].getZoom(); }
                else { state.lat = c2.lat; state.lon = c2.lng; state.zoom = maps[slot].getZoom(); }
                syncTexts();
              });
              maps[slot].on('load', function () {
                art.classList.remove('is-laden');
                var ld = el('[data-loading]'); if (ld) ld.remove();
              });
              maps[slot].on('idle', function () { art.classList.remove('is-laden'); });
            }
            if (mapBase) start(mapBase);
            else fetch(root.dataset.mapstyle).then(function (r) { return r.json(); }).then(function (b) { mapBase = b; start(b); });
          });
        }
      });
      var ld = el('[data-loading]'); if (ld && !needMap()) ld.remove();
    }
    function restyleMaps() {
      if (!mapBase) return;
      Object.keys(maps).forEach(function (k) { maps[k].setStyle(mapStyleFor(state.style, mapBase), { diff: false }); });
    }

    function syncTexts() {
      var L = LAYOUTS[state.layout];
      var k = el('[data-po-k]'), t = el('[data-po-t]'), s = el('[data-po-s]'), c = el('[data-po-c]');
      if (k) k.textContent = state.kicker || '';
      if (t) t.textContent = state.title || '';
      if (s) s.textContent = state.sub || (MODE === 'stern' ? fmtDate(state.date) : state.place.split(',')[0]);
      if (c) c.textContent = L.second ? '' : fmtCoords(state.lat, state.lon).split('').join(' ');
      if (L.second) {
        var ca = poster.querySelector('[data-cap="a"]'), cb = poster.querySelector('[data-cap="b"]');
        if (ca) ca.textContent = (state.place || '').split(',')[0].toUpperCase();
        if (cb) cb.textContent = (state.place2 || '').split(',')[0].toUpperCase();
      }
      var mp = el('[data-line-place]'); if (mp) mp.textContent = state.place;
      var md = el('[data-line-date]'); if (md) md.textContent = fmtDate(state.date) + ' · ' + pad(state.date.getHours()) + ':' + pad(state.date.getMinutes()) + ' Uhr';
      var mo = el('[data-line-moon]'); if (mo) mo.textContent = moonName(moonPhase(state.date));
      var ms = el('[data-ms]'); if (ms) ms.textContent = lastMs + ' ms';
      var fr = el('[data-frame-preview]'); if (fr) fr.className = 'lr-st__frame is-' + (state.frame === 'ohne' ? 'none' : state.frameColor);
      var pr = el('[data-price]'); if (pr) pr.textContent = money(price());
      var su = el('[data-summary]'); if (su) su.textContent = FORMATS[state.format].label + (state.frame === 'ohne' ? ' · ohne Rahmen' : ' · Rahmen ' + state.frameColor);
      setSum('1', LAYOUTS[state.layout].name);
      setSum('2', state.place.split(',')[0] + (L.second ? ' & ' + state.place2.split(',')[0] : '') + ' · ' + fmtDate(state.date));
      setSum('3', state.title || '—');
      setSum('4', FORMATS[state.format].label + ' · ' + money(price()));
      writeHash();
    }
    function money(v) { return v.toFixed(2).replace('.', ',') + ' €'; }
    function price() {
      var f = FORMATS[state.format], p = state.frame === 'ohne' ? (f.ohne || f.rahmen) : f.rahmen;
      if (state.digital) p += ADDONS.digital;
      if (state.prio) p += ADDONS.prio;
      return p;
    }
    function setSum(n, v) { var e = root.querySelector('[data-sum="' + n + '"]'); if (e) e.textContent = v; }

    /* --- Vorlagen-Bildchen --- */
    function renderThumbs() {
      all('[data-layout]').forEach(function (btn) {
        btn.setAttribute('aria-pressed', btn.dataset.layout === state.layout ? 'true' : 'false');
        var c = btn.querySelector('canvas'); if (!c) return;
        var W = 96, H = 128, dpr = 2; c.width = W * dpr; c.height = H * dpr;
        var x = c.getContext('2d'); x.setTransform(dpr, 0, 0, dpr, 0, 0);
        var st = STYLES[state.style], lay = btn.dataset.layout;
        x.fillStyle = st.paper; x.fillRect(0, 0, W, H);
        x.fillStyle = st.sky; x.strokeStyle = st.accent; x.lineWidth = .8;
        function disc(cx, cy, r) { x.beginPath(); x.arc(cx, cy, r, 0, 2 * Math.PI); x.fill(); x.stroke(); }
        if (lay === 'randlos') x.fillRect(0, 0, W, H);
        else if (lay === 'duo') { disc(28, 40, 20); disc(68, 40, 20); }
        else if (lay === 'kombi') { disc(48, 44, 32); x.fillStyle = st.land; disc(66, 78, 15); }
        else if (lay === 'herz') {
          x.beginPath(); x.moveTo(48, 68);
          x.bezierCurveTo(14, 46, 12, 26, 26, 20); x.bezierCurveTo(38, 15, 46, 24, 48, 30);
          x.bezierCurveTo(50, 24, 58, 15, 70, 20); x.bezierCurveTo(84, 26, 82, 46, 48, 68);
          x.closePath(); x.fill(); x.stroke();
        } else if (lay === 'passepartout') { x.strokeRect(6, 6, W - 12, H - 12); disc(48, 44, 26); }
        else disc(48, 42, 33);
        x.fillStyle = st.ink; x.globalAlpha = .85;
        var ty = lay === 'randlos' ? H - 26 : (lay === 'duo' ? 78 : (lay === 'kombi' ? 104 : 92));
        x.fillRect(24, ty, 48, 3.2); x.globalAlpha = .5; x.fillRect(32, ty + 8, 32, 2.2); x.globalAlpha = 1;
      });
    }

    /* --- Schritte --- */
    function openStep(n) {
      all('[data-step]').forEach(function (s) {
        var isOpen = s.dataset.step === String(n);
        s.classList.toggle('is-open', isOpen);
        if (!isOpen && +s.dataset.step < +n) s.classList.add('is-done');
        var head = s.querySelector('.lr-st__head'); if (head) head.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    }
    all('.lr-st__head').forEach(function (head) {
      head.addEventListener('click', function () { openStep(head.parentElement.dataset.step); });
    });

    /* --- Vorlage --- */
    all('[data-layout]').forEach(function (b) {
      b.addEventListener('click', function () {
        state.layout = b.dataset.layout;
        var box = el('[data-second]'); if (box) box.hidden = !LAYOUTS[state.layout].second;
        build(); openStep(2);
      });
    });

    /* --- Ortssuche --- */
    function wireSearch(inputSel, listSel, apply) {
      var input = el(inputSel), list = el(listSel); if (!input || !list) return;
      var go = debounce(function (q) {
        if (!q || q.length < 2) { list.innerHTML = ''; list.hidden = true; return; }
        fetch('https://photon.komoot.io/api/?limit=6&lang=de&q=' + encodeURIComponent(q))
          .then(function (r) { return r.json(); }).then(function (d) {
            list.innerHTML = '';
            (d.features || []).forEach(function (f) {
              var p = f.properties, co = f.geometry.coordinates;
              var label = [p.name, p.city && p.city !== p.name ? p.city : null, p.state, p.country].filter(Boolean).join(', ');
              var li = document.createElement('li'); li.tabIndex = -1; li.setAttribute('role', 'option');
              li.innerHTML = '<b>' + esc(p.name || '') + '</b><span>' + esc(label) + '</span>';
              li.addEventListener('click', function () { apply(label, co[1], co[0], p.name); input.value = label; list.hidden = true; });
              list.appendChild(li);
            });
            list.hidden = !list.children.length;
          }).catch(function () { list.hidden = true; });
      }, 150);
      input.addEventListener('input', function () { go(input.value); });
      input.addEventListener('keydown', function (e) { if (e.key === 'ArrowDown' && list.firstChild) { e.preventDefault(); list.firstChild.focus(); } if (e.key === 'Escape') list.hidden = true; });
      list.addEventListener('keydown', function (e) {
        var it = Array.prototype.slice.call(list.children), i = it.indexOf(document.activeElement);
        if (e.key === 'ArrowDown' && it[i + 1]) { e.preventDefault(); it[i + 1].focus(); }
        if (e.key === 'ArrowUp') { e.preventDefault(); (it[i - 1] || input).focus(); }
        if (e.key === 'Enter' && document.activeElement && document.activeElement.click) document.activeElement.click();
      });
      document.addEventListener('click', function (e) { if (!list.contains(e.target) && e.target !== input) list.hidden = true; });
    }
    wireSearch('[data-place-input]', '[data-place-list]', function (label, lat, lon, name) {
      state.place = label; state.lat = lat; state.lon = lon;
      if (!state.titleTouched && MODE === 'karte') {
        state.title = name || label.split(',')[0];
        var ti = el('[data-title]'); if (ti) ti.value = state.title;
      }
      if (maps.a) maps.a.flyTo({ center: [lon, lat], zoom: Math.max(state.zoom, 12.5), duration: 800 });
      paintSlots(); syncTexts();
    });
    wireSearch('[data-place2-input]', '[data-place2-list]', function (label, lat, lon) {
      state.place2 = label; state.lat2 = lat; state.lon2 = lon;
      if (maps.b) maps.b.flyTo({ center: [lon, lat], zoom: Math.max(state.zoom2, 12.5), duration: 800 });
      paintSlots(); syncTexts();
    });

    /* --- Datum, Zeit, Zoom --- */
    var dIn = el('[data-date]'), tIn = el('[data-time]'), zIn = el('[data-zoom]');
    if (dIn) {
      dIn.value = localStr(state.date).slice(0, 10);
      dIn.addEventListener('input', function () {
        var v = dIn.value.split('-');
        if (v.length === 3) { state.date = new Date(+v[0], +v[1] - 1, +v[2], state.date.getHours(), state.date.getMinutes()); paintSlots(); syncTexts(); }
      });
    }
    if (tIn) {
      tIn.value = pad(state.date.getHours()) + ':' + pad(state.date.getMinutes());
      tIn.addEventListener('input', function () {
        var v = tIn.value.split(':');
        if (v.length === 2) { state.date.setHours(+v[0], +v[1]); paintSlots(); syncTexts(); }
      });
    }
    if (zIn) { zIn.value = state.zoom; zIn.addEventListener('input', function () { state.zoom = +zIn.value; if (maps.a) maps.a.setZoom(state.zoom); }); }

    /* --- Texte --- */
    ['kicker', 'title', 'sub'].forEach(function (key) {
      var n = el('[data-' + key + ']'); if (!n) return;
      n.value = state[key] || '';
      n.addEventListener('input', function () { state[key] = n.value; if (key === 'title') state.titleTouched = true; syncTexts(); });
    });

    /* --- Feinschliff --- */
    all('[data-style]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.dataset.style === state.style ? 'true' : 'false');
      b.addEventListener('click', function () {
        state.style = b.dataset.style;
        all('[data-style]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        var st = STYLES[state.style];
        poster.style.background = st.paper; poster.style.color = st.ink; poster.style.setProperty('--po-paper', st.paper);
        var t = el('[data-po-t]'); if (t) t.style.color = st.accent;
        var veil = poster.querySelector('.lr-po__veil'); if (veil) veil.style.background = 'linear-gradient(transparent, ' + st.paper + ' 72%)';
        restyleMaps(); paintSlots(); syncTexts(); renderThumbs();
      });
    });
    all('[data-toggle]').forEach(function (b) {
      var key = b.dataset.toggle;
      b.setAttribute('aria-pressed', state[key] ? 'true' : 'false');
      b.addEventListener('click', function () { state[key] = !state[key]; b.setAttribute('aria-pressed', state[key] ? 'true' : 'false'); paintSlots(); });
    });

    /* --- Format, Rahmen, Extras --- */
    all('[data-format]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.dataset.format === state.format ? 'true' : 'false');
      b.addEventListener('click', function () {
        state.format = b.dataset.format; if (state.format === '60x40') state.frame = 'mit';
        all('[data-format]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        all('[data-frame]').forEach(function (x) { x.setAttribute('aria-pressed', x.dataset.frame === state.frame ? 'true' : 'false'); });
        syncTexts();
      });
    });
    all('[data-frame]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.dataset.frame === state.frame ? 'true' : 'false');
      b.addEventListener('click', function () {
        if (b.dataset.frame === 'ohne' && state.format === '60x40') return;
        state.frame = b.dataset.frame;
        all('[data-frame]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        syncTexts();
      });
    });
    all('[data-frame-color]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.dataset.frameColor === state.frameColor ? 'true' : 'false');
      b.addEventListener('click', function () {
        state.frameColor = b.dataset.frameColor;
        all('[data-frame-color]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        syncTexts();
      });
    });
    all('[data-addon]').forEach(function (b) {
      var key = b.dataset.addon;
      b.setAttribute('aria-pressed', state[key] ? 'true' : 'false');
      b.addEventListener('click', function () { state[key] = !state[key]; b.setAttribute('aria-pressed', state[key] ? 'true' : 'false'); syncTexts(); });
    });

    /* --- Teilen, Merken, Warenkorb --- */
    var share = el('[data-share]');
    if (share) share.addEventListener('click', function () {
      var url = location.origin + location.pathname + '#' + hashString();
      if (navigator.clipboard) navigator.clipboard.writeText(url);
      share.textContent = 'Link kopiert'; setTimeout(function () { share.textContent = 'Entwurf teilen'; }, 1600);
    });
    var keep = el('[data-keep]');
    if (keep) keep.addEventListener('click', function () {
      try {
        var list = JSON.parse(localStorage.getItem('lr-entwuerfe') || '[]');
        list.unshift({ t: Date.now(), n: (state.title || 'Entwurf') + ' · ' + state.place.split(',')[0], h: hashString() });
        localStorage.setItem('lr-entwuerfe', JSON.stringify(list.slice(0, 12)));
        keep.textContent = 'Gemerkt'; setTimeout(function () { keep.textContent = 'Entwurf merken'; }, 1600);
        showKept();
      } catch (e) {}
    });
    function showKept() {
      var box = el('[data-kept]'); if (!box) return;
      var list = [];
      try { list = JSON.parse(localStorage.getItem('lr-entwuerfe') || '[]'); } catch (e) {}
      if (!list.length) { box.hidden = true; return; }
      box.hidden = false;
      box.innerHTML = '<b>Deine Entwürfe</b>' + list.slice(0, 4).map(function (x) { return '<a href="#' + x.h + '">' + esc(x.n) + '</a>'; }).join('');
    }
    showKept();
    window.addEventListener('hashchange', function () {
      var s2 = readHash(); if (!s2) return;
      Object.keys(s2).forEach(function (k) { state[k] = s2[k]; });
      var pi2 = el('[data-place-input]'); if (pi2) pi2.value = state.place;
      build();
    });

    var form = el('[data-cart-form]');
    if (form) form.addEventListener('submit', function () {
      var L = LAYOUTS[state.layout];
      set('Vorlage', L.name); set('Stil', STYLES[state.style].name);
      set('Ort', state.place); if (L.second) set('Zweiter Ort', state.place2);
      if (MODE === 'stern' || L.mixed) {
        set('Zeitpunkt', fmtDate(state.date) + ', ' + pad(state.date.getHours()) + ':' + pad(state.date.getMinutes()));
        set('Mond', moonName(moonPhase(state.date)));
      }
      set('Koordinaten', fmtCoords(state.lat, state.lon));
      set('Überschrift', state.kicker); set('Titel', state.title); set('Zusatzzeile', state.sub);
      set('Format', FORMATS[state.format].label); set('Rahmen', state.frame === 'ohne' ? 'ohne' : state.frameColor);
      if (state.digital) set('Digitale Datei', 'ja');
      if (state.prio) set('Prio-Bearbeitung', 'ja');
      if (state.erinnerung) set('Erinnerung nächstes Jahr', fmtDate(state.date));
      set('_entwurf', hashString());
    });
    function set(name, value) {
      var n = form.querySelector('[name="properties[' + name + ']"]');
      if (!n) { n = document.createElement('input'); n.type = 'hidden'; n.name = 'properties[' + name + ']'; form.appendChild(n); }
      n.value = value == null ? '' : String(value);
    }

    /* --- Link-Zustand --- */
    function hashString() {
      var o = { y: state.layout, s: state.style, la: +state.lat.toFixed(4), lo: +state.lon.toFixed(4), p: state.place,
        la2: +state.lat2.toFixed(4), lo2: +state.lon2.toFixed(4), p2: state.place2, z: +(+state.zoom).toFixed(2),
        d: localStr(state.date), k: state.kicker, t: state.title, u: state.sub,
        l: state.lines ? 1 : 0, n: state.names ? 1 : 0, m: state.mw ? 1 : 0, g: state.grid ? 1 : 0,
        f: state.format, r: state.frame, rc: state.frameColor };
      return 'e=' + encodeURIComponent(btoa(unescape(encodeURIComponent(JSON.stringify(o)))));
    }
    function writeHash() { try { history.replaceState(null, '', '#' + hashString()); } catch (e) {} }
    function readHash() {
      try {
        var m = /e=([^&]+)/.exec(location.hash); if (!m) return null;
        var o = JSON.parse(decodeURIComponent(escape(atob(decodeURIComponent(m[1])))));
        return { layout: LAYOUTS[o.y] ? o.y : 'kreis', style: o.s, lat: o.la, lon: o.lo, place: o.p,
          lat2: o.la2, lon2: o.lo2, place2: o.p2, zoom: o.z || 13, date: parseLocal(o.d),
          kicker: o.k, title: o.t, sub: o.u, titleTouched: true,
          lines: !!o.l, names: !!o.n, mw: !!o.m, grid: !!o.g, format: o.f, frame: o.r, frameColor: o.rc };
      } catch (e) { return null; }
    }

    /* --- Start --- */
    var pi = el('[data-place-input]'); if (pi) pi.value = state.place;
    var p2 = el('[data-place2-input]'); if (p2) p2.value = state.place2;
    var sec = el('[data-second]'); if (sec) sec.hidden = !LAYOUTS[state.layout].second;
    openStep(1);
    window.addEventListener('resize', debounce(function () {
      paintSlots(); Object.keys(maps).forEach(function (k) { maps[k].resize(); });
    }, 150));
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { syncTexts(); });
  }

  function boot() {
    Array.prototype.slice.call(document.querySelectorAll('[data-lr-studio]')).forEach(function (r) {
      if (r.dataset.init) return; r.dataset.init = '1'; init(r);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.LoreliaSky = { draw: drawSky, styles: STYLES, layouts: LAYOUTS };
})();
